import { createAction } from 'redux-actions';

export const getUsersCountRequest = createAction(
  'user/get-users-count-request',
);
export const getUsersCountReceive = createAction(
  'user/get-users-count-receive',
);
